export interface AlertCategory {
  id: string;
  name: string;
}
export interface AlertDefinition {
  categoryId: AlertCategory['id'];
  definitionId: string;
  description: string;
  enabled: boolean;
  severity: AlertSeverity;
  includeInMail?: boolean;
  until?: Date;
}

export enum AlertSeverity {
  Info = 'INFO',
  Warning = 'WARNING',
  Critical = 'CRITICAL',
}

export enum AlertChannel {
  Apollo = 'APOLLO',
  Email = 'EMAIL',
}

export interface AlertMuteInfo {
  definitionId: string;
  channel: AlertChannel;
  until: Date;
}

export enum AlertTableFilter {
  Category = 'CATEGORY',
  Severity = 'SEVERITY',
  Status = 'STATUS',
}

export const SeverityFilter = [AlertSeverity.Info, AlertSeverity.Warning, AlertSeverity.Critical];

export type AlertMenuType = null | 'mute-week' | 'mute-month' | 'mute-indef' | 'umute';
export const AlertMuteMenu = ['mute-week', 'mute-month', 'mute-indef', 'umute'];

export const AlertMailDigestMenu = ['include', 'exclude'];

export enum AlertDigestInterval {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  NoDelay = 'NO-DELAY',
  Weekly = 'WEEKLY',
}

export interface EmailPayload {
  value: boolean;
  id: string;
}
export interface ApolloPayload {
  id: string;
  muteType: AlertMenuType;
}
